export default __webpack_public_path__ + "static/media/1875.2e280bd8.png";